module.exports = __webpack_public_path__ + "static/og_hunger-25588756d230ab659f0b0074747ef1b4.jpg";